import styled from 'styled-components';
import { Column } from '@simplywallst/ui-core';

export const Heading = styled.h1`
  color: white;
`;

export const Copy = styled.p`
  color: white;
  text-align: center;
`;

export const Container = styled(Column)`
  background: ${({ theme }) => theme.color.charcoal};
  position: relative;
  min-height: 100vh;
  svg {
    > path {
      fill: white;
    }
  }
  padding: 40px;
`;
